// Minimal typed emitter. Framework-free by design (SPEC §9.1): CallEngine
// events feed the UI's store from OUTSIDE any rendering framework (§9.3.1).

export type Listener<T extends unknown[]> = (...args: T) => void;

export class Emitter<E extends Record<string, unknown[]>> {
  private listeners = new Map<keyof E, Set<Listener<unknown[]>>>();

  on<K extends keyof E>(event: K, fn: Listener<E[K]>): () => void {
    let set = this.listeners.get(event);
    if (!set) {
      set = new Set();
      this.listeners.set(event, set);
    }
    set.add(fn as Listener<unknown[]>);
    return () => this.off(event, fn);
  }

  off<K extends keyof E>(event: K, fn: Listener<E[K]>): void {
    this.listeners.get(event)?.delete(fn as Listener<unknown[]>);
  }

  emit<K extends keyof E>(event: K, ...args: E[K]): void {
    this.listeners.get(event)?.forEach((fn) => {
      fn(...args);
    });
  }

  removeAll(): void {
    this.listeners.clear();
  }
}
